import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { sortBy } from 'lodash';
import { debounceTime, Subject } from 'rxjs';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { MemberService } from 'src/app/services/core/member/member.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styleUrls: ['./member-list.component.css']
})
export class MemberListComponent implements OnInit {
  search: any
  members: any;
  filteredMemberList: any
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  status = true
  numberOfRecords = NUMBER_OF_RECORDS
  memberDetail: any;
  private readonly searchSubject = new Subject<string | undefined>();
  memberData: any;
  userPermission = UserPermission
  editMemberObj: any;


  constructor(
    private memberService: MemberService,
    public permissionService: PermissionService
  ) { }
  ngOnInit() {
    this.getAllMembers(this.currentPage)
    this.listenSearch();
  }

  getAllMembers(page: number) {
  let queryParams: any = {
    limit: this.numberOfRecords,
    page,
    isActive: this.status,
    sortBy: 'createdAt:desc',
  };

  const search = (this.search || '').trim();
  if (search) queryParams['search'] = search;
  
  const request = search
    ? this.memberService.searchMembers(queryParams)
    : this.memberService.getMembers(queryParams);

  request
    .pipe(untilDestroyed(this))
    .subscribe((data: any) => {
      if (data && data.results) {
        this.members = data.results;
        this.totalPages = data.totalPages;
        this.totalResults = data.totalResults;
      }
    });
  }

  onSearch(query: any) {
    this.searchSubject.next(query);
  }
  
  listenSearch() {
    this.searchSubject
      .pipe(debounceTime(500), untilDestroyed(this))
      .subscribe((search) => {
        this.currentPage = 1;
        this.members = [];
        this.getAllMembers(this.currentPage);
      });
  }



  onPageChange(page: number) {
    this.currentPage = page;
    this.getAllMembers(page);
  }


  onSelectStatus(event: any): void {
    this.status = event.target.value
    this.members = [];
    this.getAllMembers(this.currentPage = 1);
  }

  memberTrips(data: any) {
    this.memberDetail = data;
  }

  opendetailModal(member: any) {
    this.memberData = member
  }

  openMemberEditModal(member: any) {
    this.editMemberObj = member;
  }


  onSaveMember(evt: any) {
    if (evt) {
      const idx = this.members.findIndex((member: any) => member.id === evt.id);
      if (this.status === evt.isActive) {
        this.members[idx] = { ...evt, fullName: `${evt.firstName} ${evt.lastName}`.trim() };
      } else {
        this.members.splice(idx, 1);
      }
    }
    this.editMemberObj = null;
  }

}
